module.exports = __webpack_public_path__ + "img/c0c8a90.jpg";